import type { ContextSlug } from "@/entities/context";

import { useUpdateSettingsContext } from "@/entities/settings";
import {
  useOrganizationContext,
  useOrganizationContextList,
  useOrganizationContextNavigate,
} from "@/modules/organization/organization-context";

export const useOrganizationContextSelect = () => {
  const { contextSlug } = useOrganizationContext();
  const { organizations } = useOrganizationContextList();
  const { navigateToContext } = useOrganizationContextNavigate();
  const { mutate } = useUpdateSettingsContext();

  const value = contextSlug;

  const options = organizations.map((organization) => ({
    label: organization.name,
    value: organization.slug,
  }));

  const onContextChange = (newContext: ContextSlug) => {
    // Only mutate when the context is not in the url. Otherwise,
    // the mutation will be handled by `useOrganizationContextSync()`
    // which update context based on url param changes.
    const { hasNavigate } = navigateToContext(newContext);
    if (!hasNavigate) mutate(newContext);
  };

  return {
    value,
    options,
    onContextChange,
  };
};
